import { LoanEscrowAccount } from './LoanEscrowAccount';

export default LoanEscrowAccount;
